import { combineReducers } from 'redux'

import accountsUsers from './accountsUsers'
import accountsOrgs from './accountsOrgs'
import accountsAuthOrgs from './accountsAuthOrgs'

const accounts = combineReducers({
  accountsUsers,
  accountsOrgs,
  accountsAuthOrgs,
})

export default accounts
